module.exports = "https://r.nearpod.com/assets/media/image/classlink-icon-8670b811fe0deb64f024fcc594e91b83.svg";